<h2>Start number change tool</h2>

<form novalidate *ngIf="canCommand">
  <div *ngIf="(race$ | async) as race">
    <h1>{{ race.racePlan.name }} <small>({{ race.racePlan.resultsCouchDbName }})</small></h1>

    <h4>From:</h4>
    <div class="form-row">
      <div class="form-group">
        <input
          type="number"
          value=""
          class="form-control-md"
          #sourceDriverIdInput
        />
      </div>

      <button class="btn btn-primary" (click)="listLaps(+sourceDriverIdInput.value)">Show</button>
    </div>

    <div *ngIf="isLoaded === false">Loading...</div>
    <div *ngIf="(sourceDriverId$ | async) as sourceDriverId" [hidden]="!isLoaded">
      <div *ngIf="(laps$ | async) as laps">

        <h4>{{ laps.length }} results of driver #{{ sourceDriverId }}</h4>

        <div *ngFor="let result of laps">
          <div class="row result">
            <div class="col-3 laptime">
              <mc-result
                [result]="result"
                (click)="$event.stopPropagation()"
              ></mc-result>
            </div>
            <div class="col-3 created-at">
              at {{ result.createdAt | date:'HH:mm:ss' }}
            </div>
            <div class="col-6 result-id">
              #{{ result._id }}
            </div>
          </div>
        </div>

        <h4>Move to driver:</h4>

        <div class="form-group">
          <input
            type="number"
            value=""
            class="form-control-md"
            #targetDriverIdInput
          />
          <button class="btn btn-primary" (click)="moveResultsToDriver(laps, +targetDriverIdInput.value)">Move</button>
        </div>
      </div>
    </div>

  </div>
</form>
